import React from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarPlus, faUserMd } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";

const BannerVerticalCarousel = ({ carouselItems }) => {
  const scroll = () => {
    switch (carouselItems.length) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 3:
        return 3;
      default:
        return 3;
    }
  };
  const settings = {
    dots: true,
    autoplay: true,
    vertical: true,
    infinite: true,
    arrows: true,
    slidesToShow: scroll(carouselItems),
    slidesToScroll: scroll(carouselItems),
    verticalSwiping: true,
    speed: 3500,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: scroll(carouselItems),
          slidesToScroll: scroll(carouselItems),
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: scroll(carouselItems),
          slidesToScroll: scroll(carouselItems),
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: carouselItems.length < 2 ? 1 : 2,
          slidesToScroll: carouselItems.length < 2 ? 1 : 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const bannerData = carouselItems?.map((item) => {
    if (item.name === "") {
      return null;
    }
    return (
      <div className="card card_pd">
        <div className="d-flex">
          <div className="flex-shrink-0 card_img">
            {/* <img
            src={item.photo}
            className="rounded-circle"
            alt={item.title}
          /> */}
            {item.photo ? (
              <img
                src={item.photo}
                className="rounded-circle"
                alt={item.title}
              />
            ) : (
              <div className="doctors_icon_div">
                <FontAwesomeIcon icon={faUserMd} className="doctors_icons" />
              </div>
            )}
          </div>
          <div className="flex-grow-1 card_details">
            <h2>
              <a
                href={item.profile_link === "" ? "#" : item.profile_link}
                className={
                  item.profile_link !== "" ? "profile_link_atag" : null
                }
                // target="_blank"
                rel="noreferrer"
                target={item.profile_link === "" ? null : "_blank"}
              >
                {item.name ? item.name : null}
              </a>{" "}
              <span className="card_title">
                {item.specialty ? item.specialty : null}
              </span>
            </h2>
            <h4>
              {item.qualification ? item.qualification : null}
              <span className="linkedin_main_div">
                {item.linkedin !== "" ? (
                  <a href={item.linkedin} target="_blank" rel="noreferrer">
                    <StaticImage
                      className="doctor_linkedin"
                      src="../../../assets/images/kmc-images/Doctors/linkedin-circled.png"
                      alt="linkedin"
                    />
                  </a>
                ) : null}
              </span>
            </h4>
            <p>
              <FontAwesomeIcon icon={faCalendarPlus} />{" "}
              {item.date_time_of_visit ? item.date_time_of_visit : null}
            </p>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div
      className={
        carouselItems.length < 3
          ? `slider-caro ${carouselItems.length < 2 ? "check_gp" : "check_gp2"}`
          : "slider sidebar"
      }
    >
      <Slider
        {...settings}
        className={carouselItems.length < 3 ? "slider-caro" : "slider-car-2"}
      >
        {bannerData}
      </Slider>
    </div>
  );
};
BannerVerticalCarousel.propTypes = {
  carouselItems: PropTypes.string.isRequired,
};

export default BannerVerticalCarousel;
